import { ChevronRight } from '@mui/icons-material'
import { Avatar, Box, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material'
import { PublicationIcon, SaveIcon } from '../../../core/global/Icons'
import { useHistory } from "react-router-dom";
import React from 'react';

export const Mobile = () => {
	const history = useHistory();

    let data_item = [
        {
            features: 'Publication',
            description: 'Discover articles, news, and updates shared by different authors.',
            icon: <PublicationIcon type="active" />,
            name: 'publication'
        },
        {
            features: 'Save',
            description: 'Access the items you’ve bookmarked for later reading.',
            icon: <SaveIcon width={22} height={22} type="active"/>,
            name: 'save'
        },
    ]

    const clickHandler = (name) => {
        if (name === 'publication'){
            history.push('/psl/publication?tab=article')
        } else if (name === 'save'){
            history.push('/psl/save')
        }  
    }

	return (
		<Box width="100%" height="100%" display="flex" justifyContent="center" alignItems="center" flexDirection="column" bgcolor="#fff">
            <Box display="flex" alignItems="center" flexDirection="column" my="16px" p="16px">
                <Box fontSize="16px" color="#453FBA" fontWeight="600">404</Box>
                <Box fontSize="28px" fontWeight="700" mt="16px" mb="8px">Oops! Page Not Found.</Box>
                <Box fontSize="14px" color="#6b6b6b" textAlign="center" >It seems the page you're looking for doesn't exist or may have been moved.</Box>
            </Box>
            <Box>
                <List>
                    {data_item.map((v, i) => (
						<React.Fragment key={i}>
							<ListItem onClick={() => clickHandler(v.name)} disablePadding sx={{ width: '100%' }}>
								<ListItemButton>
									<ListItemAvatar>
										<Avatar sx={{ background: '#d6e4f3' }}>{v.icon}</Avatar>
									</ListItemAvatar>
									<ListItemText 
										primary={<Box fontSize="14px" fontWeight="600">{v.features}</Box>}
										secondary={<Box fontSize="12px">{v.description}</Box>}
									/>
									<IconButton edge="end" aria-label="navigate">
										<ChevronRight />
									</IconButton>
								</ListItemButton>
							</ListItem>
							{i !== data_item.length - 1 && <Divider variant="middle" />}
						</React.Fragment>
					))}
                </List>
            </Box>
        </Box>
	)
}
